import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LoggerService } from '../../core/logger.service';
import { BlendEvent } from '../../shared/models';
import { BlendService } from '../../shared/services/blend.service';
import { IFile } from 'src/sync';
import { uint8ArrayToBase64 } from 'uint8array-extras';
import { FileItemService } from '../file-item.service';

@Component({
  selector: 'app-preview-audio',
  templateUrl: './preview-audio.component.html',
  styleUrls: ['./preview-audio.component.scss']
})
export class PreviewAudioComponent implements OnInit, OnChanges {

  @Input() public item: IFile;
  @Input() audioUrl: string;
  @Input() mimeType: string;
  public url: string;
  public thumbnailUrl: string;
  public isAudioReady = false;

  constructor(
    private loggerService: LoggerService,
    private blendService: BlendService,
    private fileItemService: FileItemService
  ) { }

  ngOnInit() {
    this.init();

    // Fallback: add timeout to show audio preview if canplay or loadedmetadata doesn't fire
    // On some browsers (like Safari on iOS), audio events may not trigger automatically,
    // which can cause the loading spinner to stay visible
    setTimeout(() => {
      if (!this.isAudioReady) {
        this.loggerService.info('Fallback: setting isAudioReady = true after timeout');
        this.isAudioReady = true;
      }
    }, 3000); 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.item &&
      changes.item.currentValue?.sync_id &&
      changes.item.previousValue?.sync_id &&
      changes.item.currentValue.sync_id !== changes.item.previousValue.sync_id) || changes.audioUrl
    ) {
      this.init();
    }
  }

  private init() {
    this.url = this.audioUrl;
    this.loggerService.info(`url : ${this.url}`);
    this.loggerService.info(`mimeType : ${this.mimeType}`);

    this.extractThumbnail(this.audioUrl);

    this.blendService.track(BlendEvent.VIEW_FILE, {
      type: 'audio',
      preview_preference: 'N/A',
      fileSize: this.item.filesize,
      mimeType: this.item.mime_type
    });
  }

  public async extractThumbnail(url: string) {
    try {
      const response = await fetch(url);
      const data = await response.blob();
      const metadata = {
        type: 'audio/mpeg'
      };
      const file = new File([data], this.item.name, metadata);
      const metadataResp = await this.fileItemService.parseBlob(file);
      if (metadataResp.common?.picture && metadataResp.common.picture.length > 0) {
      const picture = metadataResp.common.picture[0];
      this.thumbnailUrl = `data:${picture.format};base64,${uint8ArrayToBase64(picture.data)}`;
      };
    } catch (error) {
      this.loggerService.info(`Error fetching thumbnail: ${error.message}`);
      this.thumbnailUrl = undefined;
    }
  }
  
  
  onCanPlay() {
    this.isAudioReady = true;
  }
}
